class UHMobileNav {
  toggle: HTMLButtonElement | null;
  navbar: HTMLDivElement | null;
  isOpen: boolean;

  constructor() {
    this.isOpen = false;
    this.toggle = document.querySelector("#navbar-toggle");
    this.navbar = document.querySelector("#navbar");
  }

  init() {
    this.toggle.addEventListener("click", () => this.toggleNavigation());
  }

  toggleNavigation() {
    if (this.toggle && this.navbar) {
      this.isOpen = !this.isOpen;
      this.updateSidebar();
    }
  }

  updateSidebar() {
    if (this.toggle && this.navbar) {
      if (this.isOpen) {
        this.toggle.classList.add(`toggled`);
        this.navbar.classList.add(`opened`);
      } else {
        this.toggle.classList.remove(`toggled`);
        this.navbar.classList.remove(`opened`);
      }
    }
  }
}

export default new UHMobileNav();
